module.exports = __webpack_public_path__ + "img/icon_证书_D级赛事@3x.3dec683a.png";